import {
  LIST_VEHICLES,
  LIST_VEHICLES_SUCCESS,
  LIST_VEHICLES_FAILURE,
  CREATE_VEHICLE,
  CREATE_VEHICLE_SUCCESS,
  CREATE_VEHICLE_FAILURE,
  DELETE_VEHICLE,
  DELETE_VEHICLE_SUCCESS,
  DELETE_VEHICLE_FAILURE,
  UPDATE_VEHICLE,
  UPDATE_VEHICLE_SUCCESS,
  UPDATE_VEHICLE_FAILURE,
  GET_VEHICLE_DETAILS,
  GET_VEHICLE_DETAILS_SUCCESS,
  GET_VEHICLE_DETAILS_FAILURE,
  VEHICLE_STATUS_LIST,
  VEHICLE_STATUS_LIST_SUCCESS,
  VEHICLE_STATUS_LIST_FAILURE,
  VEHICLE_TYPE_LIST,
  VEHICLE_TYPE_LIST_SUCCESS,
  VEHICLE_TYPE_LIST_FAILURE,
  VEHICLE_STATUS_CREATE,
  VEHICLE_STATUS_CREATE_SUCCESS,
  VEHICLE_STATUS_CREATE_FAILURE,
  VEHICLE_TYPE_CREATE,
  VEHICLE_TYPE_CREATE_SUCCESS,
  VEHICLE_TYPE_CREATE_FAILURE,
  VEHICLE_STATUS_UPDATE,
  VEHICLE_STATUS_UPDATE_SUCCESS,
  VEHICLE_STATUS_UPDATE_FAILURE,
  VEHICLE_TYPE_UPDATE,
  VEHICLE_TYPE_UPDATE_SUCCESS,
  VEHICLE_TYPE_UPDATE_FAILURE,
  VEHICLE_STATUS_DELETE,
  VEHICLE_STATUS_DELETE_SUCCESS,
  VEHICLE_STATUS_DELETE_FAILURE,
  VEHICLE_TYPE_DELETE,
  VEHICLE_TYPE_DELETE_SUCCESS,
  VEHICLE_TYPE_DELETE_FAILURE,
  VEHICLE_STATUS_DETAILS,
  VEHICLE_STATUS_DETAILS_SUCCESS,
  VEHICLE_STATUS_DETAILS_FAILURE,
  VEHICLE_RECENT_ACTIVITY_LIST,
  VEHICLE_RECENT_ACTIVITY_LIST_SUCCESS,
  VEHICLE_RECENT_ACTIVITY_LIST_FAILURE,
  VEHICLE_SEARCH,
  VEHICLE_SEARCH_SUCCESS,
  VEHICLE_SEARCH_FAILURE,
} from "./actionType";

// List Vehicles
export const listVehicles = () => {
  return {
    type: LIST_VEHICLES,
  };
};

export const listVehiclesSuccess = (vehicles) => {
  return {
    type: LIST_VEHICLES_SUCCESS,
    payload: vehicles,
  };
};

export const listVehiclesFailure = (error) => {
  return {
    type: LIST_VEHICLES_FAILURE,
    payload: error,
  };
};

// Create Vehicle
export const createVehicle = (vehicle) => {
  return {
    type: CREATE_VEHICLE,
    payload: vehicle,
  };
};

export const createVehicleSuccess = (vehicle) => {
  return {
    type: CREATE_VEHICLE_SUCCESS,
    payload: vehicle,
  };
};

export const createVehicleFailure = (error) => {
  return {
    type: CREATE_VEHICLE_FAILURE,
    payload: error,
  };
};

// Delete Vehicle
export const deleteVehicle = (id) => {
  return {
    type: DELETE_VEHICLE,
    payload: id,
  };
};

export const deleteVehicleSuccess = (id) => {
  return {
    type: DELETE_VEHICLE_SUCCESS,
    payload: id,
  };
};

export const deleteVehicleFailure = (error) => {
  return {
    type: DELETE_VEHICLE_FAILURE,
    payload: error,
  };
};

// Update Vehicle
export const updateVehicle = (vehicle) => {
  return {
    type: UPDATE_VEHICLE,
    payload: vehicle,
  };
};

export const updateVehicleSuccess = (vehicle) => {
  return {
    type: UPDATE_VEHICLE_SUCCESS,
    payload: vehicle,
  };
};

export const updateVehicleFailure = (error) => {
  return {
    type: UPDATE_VEHICLE_FAILURE,
    payload: error,
  };
};

// Get Vehicle Details
export const getVehicleDetails = (id) => {
  return {
    type: GET_VEHICLE_DETAILS,
    payload: id,
  };
};

export const getVehicleDetailsSuccess = (vehicle) => {
  return {
    type: GET_VEHICLE_DETAILS_SUCCESS,
    payload: vehicle,
  };
};

export const getVehicleDetailsFailure = (error) => {
  return {
    type: GET_VEHICLE_DETAILS_FAILURE,
    payload: error,
  };
};

// List Vehicle Status
export const listVehicleStatus = () => {
  return {
    type: VEHICLE_STATUS_LIST,
  };
};

export const listVehicleStatusSuccess = (vehicleStatus) => {
  return {
    type: VEHICLE_STATUS_LIST_SUCCESS,
    payload: vehicleStatus,
  };
};

export const listVehicleStatusFailure = (error) => {
  return {
    type: VEHICLE_STATUS_LIST_FAILURE,
    payload: error,
  };
};

// List Vehicle Type
export const listVehicleType = () => {
  return {
    type: VEHICLE_TYPE_LIST,
  };
};

export const listVehicleTypeSuccess = (vehicleType) => {
  return {
    type: VEHICLE_TYPE_LIST_SUCCESS,
    payload: vehicleType,
  };
};

export const listVehicleTypeFailure = (error) => {
  return {
    type: VEHICLE_TYPE_LIST_FAILURE,
    payload: error,
  };
};

// Create Vehicle Status
export const createVehicleStatus = (vehicleStatus) => {
  return {
    type: VEHICLE_STATUS_CREATE,
    payload: vehicleStatus,
  };
};

export const createVehicleStatusSuccess = (vehicleStatus) => {
  return {
    type: VEHICLE_STATUS_CREATE_SUCCESS,
    payload: vehicleStatus,
  };
};

export const createVehicleStatusFailure = (error) => {
  return {
    type: VEHICLE_STATUS_CREATE_FAILURE,
    payload: error,
  };
};

// Create Vehicle Type
export const createVehicleType = (vehicleType) => {
  return {
    type: VEHICLE_TYPE_CREATE,
    payload: vehicleType,
  };
};

export const createVehicleTypeSuccess = (vehicleType) => {
  return {
    type: VEHICLE_TYPE_CREATE_SUCCESS,
    payload: vehicleType,
  };
};

export const createVehicleTypeFailure = (error) => {
  return {
    type: VEHICLE_TYPE_CREATE_FAILURE,
    payload: error,
  };
};

// Update Vehicle Status
export const updateVehicleStatus = (vehicleStatus) => {
  return {
    type: VEHICLE_STATUS_UPDATE,
    payload: vehicleStatus,
  };
};

export const updateVehicleStatusSuccess = (vehicleStatus) => {
  return {
    type: VEHICLE_STATUS_UPDATE_SUCCESS,
    payload: vehicleStatus,
  };
};

export const updateVehicleStatusFailure = (error) => {
  return {
    type: VEHICLE_STATUS_UPDATE_FAILURE,
    payload: error,
  };
};

// Update Vehicle Type
export const updateVehicleType = (vehicleType) => {
  return {
    type: VEHICLE_TYPE_UPDATE,
    payload: vehicleType,
  };
};

export const updateVehicleTypeSuccess = (vehicleType) => {
  return {
    type: VEHICLE_TYPE_UPDATE_SUCCESS,
    payload: vehicleType,
  };
};

export const updateVehicleTypeFailure = (error) => {
  return {
    type: VEHICLE_TYPE_UPDATE_FAILURE,
    payload: error,
  };
};

// Delete Vehicle Status
export const deleteVehicleStatus = (id) => {
  return {
    type: VEHICLE_STATUS_DELETE,
    payload: id,
  };
};

export const deleteVehicleStatusSuccess = (id) => {
  return {
    type: VEHICLE_STATUS_DELETE_SUCCESS,
    payload: id,
  };
};

export const deleteVehicleStatusFailure = (error) => {
  return {
    type: VEHICLE_STATUS_DELETE_FAILURE,
    payload: error,
  };
};

// Delete Vehicle Type
export const deleteVehicleType = (id) => {
  return {
    type: VEHICLE_TYPE_DELETE,
    payload: id,
  };
};

export const deleteVehicleTypeSuccess = (id) => {
  return {
    type: VEHICLE_TYPE_DELETE_SUCCESS,
    payload: id,
  };
};

export const deleteVehicleTypeFailure = (error) => {
  return {
    type: VEHICLE_TYPE_DELETE_FAILURE,
    payload: error,
  };
};

// Get Vehicle Status Details
export const getVehicleStatusDetails = (id) => {
  return {
    type: VEHICLE_STATUS_DETAILS,
    payload: id,
  };
};

export const getVehicleStatusDetailsSuccess = (vehicleStatus) => {
  return {
    type: VEHICLE_STATUS_DETAILS_SUCCESS,
    payload: vehicleStatus,
  };
};

export const getVehicleStatusDetailsFailure = (error) => {
  return {
    type: VEHICLE_STATUS_DETAILS_FAILURE,
    payload: error,
  };
};

// List Vehicle Recent Activity
export const listVehicleRecentActivity = (id) => {
  return {
    type: VEHICLE_RECENT_ACTIVITY_LIST,
    payload: id,
  };
};

export const listVehicleRecentActivitySuccess = (vehicleRecentActivity) => {
  return {
    type: VEHICLE_RECENT_ACTIVITY_LIST_SUCCESS,
    payload: vehicleRecentActivity,
  };
};

export const listVehicleRecentActivityFailure = (error) => {
  return {
    type: VEHICLE_RECENT_ACTIVITY_LIST_FAILURE,
    payload: error,
  };
};

// Search Vehicle
export const searchVehicle = (search) => {
  return {
    type: VEHICLE_SEARCH,
    payload: search,
  };
};

export const searchVehicleSuccess = (vehicles) => {
  return {
    type: VEHICLE_SEARCH_SUCCESS,
    payload: vehicles,
  };
};

export const searchVehicleFailure = (error) => {
  return {
    type: VEHICLE_SEARCH_FAILURE,
    payload: error,
  };
};
